import React from 'react';
import PackShotAndThumbnail from "./PackshotAndThumbnail";
import GeneratePackshots from "./GeneratePackshots";
import { useSelector } from "react-redux";
import NestedDropDownGlobalSearch from './NestedDropDownGlobalSearch';

const GlobalSearch = () => {
    const { packshots, open, clickedThumbnail, selectedSku } = useSelector(
        (state) => state.conflictsPageStore
      );
      const {
        conflicts,
        curConflict,
        conflictedBrands,
        selectedConflictBrand,
        selectedThumbnailsToMarkCorrect,
      } = useSelector((state) => state.conflictDataStore);
  return (
    <>
      <NestedDropDownGlobalSearch {...clickedThumbnail} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "1rem",
         // marginBottom: "2rem",
        }}
      >
        <PackShotAndThumbnail
          selectedThumbnailsToMarkCorrect={selectedThumbnailsToMarkCorrect}
        />
        <GeneratePackshots packshots={packshots} />
      </div>
    </>
  )
}

export default GlobalSearch